/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { isJDXHomePage, isSRSMFlag } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class ApiContactService {
  URL = {
    contacts: "/contacts/all",
    createContact: "/contacts",
    companies: "/companies",
    contactCustomers: "/contacts/customers",
    contactSuppliers: "/contacts/suppliers",
    contactConsumers: "/consumersList",
    consumerTags: "/consumerTags",
    updateConsumerTags: "/consumers",
    getConsumerGroups: "/consumerGroups",
    createConsumerGroups: "/consumerGroups",
    viewConsumerGroup: "/consumerGroups",
    updateConsumerGroup: "/consumerGroups",
    getTotalConsumers: "/consumersByCriteria",
    getConsumerFilter: "/consumersFilterData",
    addConsumer: "/consumer",
    updateConsumerWithUserData: "/consumerByUserData",
    getConsumer: "/consumers/",
  };
  constructor(private http: HttpClient) {}

  getContacts(all = false, page = 1, limit = 10) {
    const httpParams = new HttpParams().set("isWhiteShop", "true");
    if (!all) {
      httpParams
        // set('external', 'true')
        .set("page", page.toString())
        .set("limit", limit.toString());
    }
    return this.http.get<any>(environment.server + this.URL.contacts, {
      params: httpParams,
    });
  }
  createContact(data) {
    if (isJDXHomePage.flag || isSRSMFlag.flag) {
      data["isJDX"] = true;
    }
    return this.http.post<any>(
      environment.server + this.URL.createContact,
      data
    );
  }
  updateContact(data) {
    if (isJDXHomePage.flag) {
      data["isJDX"] = true;
    }
    return this.http.put<any>(
      environment.server + this.URL.createContact + "/" + data._id,
      data
    );
  }
  getCompany(id) {
    return this.http.get<any>(
      environment.server + this.URL.companies + "/" + id
    );
  }
  updateCompany(data) {
    return this.http.put<any>(
      environment.server + this.URL.companies + "/" + data._id,
      data
    );
  }
  getCustomerContacts(page?, limit = 10) {
    const httpParams = new HttpParams().set("isWhiteShop", "true");
    if (page) {
      httpParams.set("page", page.toString()).set("limit", limit.toString());
    }
    return this.http.get<any>(environment.server + this.URL.contactCustomers, {
      params: httpParams,
    });
  }
  getCustomerSuppliers(page?, limit = 10) {
    const httpParams = new HttpParams().set("isWhiteShop", "true");
    if (page) {
      httpParams.set("page", page.toString()).set("limit", limit.toString());
    }
    return this.http.get<any>(environment.server + this.URL.contactSuppliers, {
      params: httpParams,
    });
  }
  getConsumers(
    type?,
    isNewsLetter?,
    isContactsModule?,
    searchText?,
    page?,
    limit = 10,
    tags?,
    locations?,
    ages?,
    genders?,
    filtersData?,
    member?,
    isboostLink?
  ) {
    let httpParams = new HttpParams();
    let data = {};
    if (type) {
      data[type] = true;
    }
    if (isNewsLetter !== undefined) {
      data["isNewsLetter"] = isNewsLetter;
    }
    if (page) {
      data["page"] = page;
      data["limit"] = limit;
    }
    if (isboostLink) {
      data["isBoostLink"] = true;
    }
    if (isContactsModule) {
      data["isContactsModule"] = true;
    }
    if (searchText) {
      data["searchText"] = searchText;
      data["searchField"] =
        type || member
          ? "name,gender,phone,email,currentLocation"
          : "name,phone,email";
    }
    if (tags) {
      data["tags"] = tags;
    }
    if (locations) {
      data["locations"] = locations;
    }
    if (ages) {
      data["age"] = ages;
    }
    if (genders) {
      data["gender"] = genders;
    }
    if (member) {
      data["Member"] = true;
    }
    if (filtersData) {
      if (filtersData.tags) {
        data["filterTags"] = filtersData.tags;
      }
      if (filtersData.locations) {
        data["filterLocations"] = filtersData.locations;
      }
      if (filtersData.age) {
        data["filterAges"] = filtersData.age;
      }
      if (filtersData.gender) {
        data["filterGenders"] = filtersData.gender;
      }
    }
    // if (!type && !member) {
    //   data["sortByName"] = "true";
    // }
    return this.http.get<any>(environment.server + this.URL.contactConsumers, {
      params: data,
    });
  }
  getConsumerTags() {
    const httpParams = new HttpParams();
    return this.http.get<any>(environment.server + this.URL.consumerTags, {
      params: httpParams,
    });
  }
  updateConsumerTag(id, data) {
    return this.http.put<any>(
      environment.server + this.URL.updateConsumerTags + "/" + id,
      data
    );
  }
  getConsumerGroups(searchText?, page?, limit = 10) {
    let httpParams = new HttpParams();
    if (page) {
      httpParams = httpParams
        .set("page", page.toString())
        .set("limit", limit.toString());
    }
    if (searchText) {
      httpParams = httpParams.set("searchText", searchText);
    }
    if (searchText) {
      httpParams = httpParams.set("searchField", "name,groupClassification");
    }
    return this.http.get<any>(environment.server + this.URL.getConsumerGroups, {
      params: httpParams,
    });
  }
  createConsumerGroup(data) {
    return this.http.post<any>(
      environment.server + this.URL.createConsumerGroups,
      data
    );
  }
  viewConsumerGroup(id, searchText?, page?, limit = 10) {
    let httpParams = new HttpParams();
    if (page) {
      httpParams = httpParams
        .set("page", page.toString())
        .set("limit", limit.toString());
    }
    if (searchText) {
      httpParams = httpParams.set("searchText", searchText);
    }
    if (searchText) {
      httpParams = httpParams.set("searchField", "name,gender,phone,email");
    }
    return this.http.get<any>(
      environment.server + this.URL.viewConsumerGroup + "/" + id,
      {
        params: httpParams,
      }
    );
  }
  updateConsumerGroup(id, data) {
    return this.http.put<any>(
      environment.server + this.URL.updateConsumerGroup + "/" + id,
      data
    );
  }
  getConsumersData(data, limit, skipCount) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("criteria", data);
    httpParams = httpParams.set("limit", limit.toString());
    httpParams = httpParams.set("skipCount", skipCount);
    return this.http.get<any>(environment.server + this.URL.getTotalConsumers, {
      params: httpParams,
    });
  }
  getConsumerFilters(type?, isGroup?) {
    let httpParams = new HttpParams();
    if (type) {
      httpParams = httpParams.set("isMember", type);
    }
    if (isGroup) {
      httpParams = httpParams.set("isGroup", isGroup);
    }
    return this.http.get<any>(environment.server + this.URL.getConsumerFilter, {
      params: httpParams,
    });
  }

  updateConsumerData(data) {
    return this.http.post<any>(
      environment.server + this.URL.updateConsumerWithUserData,
      data
    );
  }

  addNewConsumer(data) {
    return this.http.post<any>(environment.server + this.URL.addConsumer, data);
  }

  getConsumer(consumerId) {
    return this.http.get<any>(
      environment.server + this.URL.getConsumer + consumerId
    );
  }
}
